import { RouteConfig } from "vue-router";
import { Route } from "vue-router/types/router";
import config from "@/config";
import { enrichRouteMeta } from "@/router/helpers";
import { profileRoutes } from "@/router/routes/profile";
import { CreatorsTabsEnum } from "@/views/PageCreatorsList/types";

const routes: RouteConfig[] = [
  {
    path: "/",
    name: "home",
    components: {
      default: () => import("@/views/PageHome"),
    },
    props: {
      default: (route: Route) => ({
        tags: typeof route.query.tag === "string" ? [route.query.tag] : route.query.tag,
        languages: typeof route.query.language === "string" ? [route.query.language] : route.query.language,
        locations: typeof route.query.location === "string" ? [route.query.location] : route.query.location,
      }),
    },
  },
  ...(config.featureLoginAsUser
    ? [
        {
          path: "/login/token/:token",
          name: "loginToken",
          component: () => import("@/views/PageLoginToken"),
          props: (route: Route) => ({
            token: route.params.token,
            path: route.query.path,
          }),
        },
      ]
    : []),
  {
    path: "/logout",
    name: "logout",
  },
  {
    path: "/participant-consent-link/:urlUuid",
    name: "participantConsentLink",
    component: () => import("@/views/PageParticipantConsent/PageParticipantConsentLink.vue"),
    props: (route: Route) => ({
      urlUuid: route.params.urlUuid,
      forceReject: route.query.reject !== undefined,
    }),
  },
  {
    path: "/participant-consent-link/:urlUuid/form",
    name: "participantConsentLinkForm",
    component: () => import("@/views/PageParticipantConsent"),
    props: (route: Route) => ({
      urlUuid: route.params.urlUuid,
    }),
  },
  ...(!config.featurePrivateProfile ? profileRoutes : []),
  ...(!config.featureSoloModel
    ? [
        {
          path: "/discover",
          name: "discover",
          props: {
            default: (route: Route) => ({
              onFeed: false,
              tagSlugs: typeof route.query.tag === "string" ? [route.query.tag] : route.query.tag,
              hashtagSlugs: typeof route.query.hashtag === "string" ? [route.query.hashtag] : route.query.hashtag,
              languages: typeof route.query.language === "string" ? [route.query.language] : route.query.language,
              locations: typeof route.query.location === "string" ? [route.query.location] : route.query.location,
              sort: route.query.sort,
            }),
          },
          components: {
            default: () => import("@/views/PageDiscover"),
            unlockFeed: () => import(/* webpackChunkName: "profile" */ "@/views/UnlockFeed"),
          },
        },
        {
          path: "/discover/feed",
          name: "discoverFeed",
          props: {
            default: (route: Route) => ({
              onFeed: true,
              tagSlugs: typeof route.query.tag === "string" ? [route.query.tag] : route.query.tag,
              hashtagSlugs: typeof route.query.hashtag === "string" ? [route.query.hashtag] : route.query.hashtag,
              languages: typeof route.query.language === "string" ? [route.query.language] : route.query.language,
              locations: typeof route.query.location === "string" ? [route.query.location] : route.query.location,
              sort: route.query.sort,
            }),
          },
          components: {
            default: () => import("@/views/PageDiscover"),
            unlockFeed: () => import(/* webpackChunkName: "profile" */ "@/views/UnlockFeed"),
          },
        },
      ]
    : []),

  {
    path: "/complaints",
    name: "complaints",
    components: {
      default: () => import("@/views/PageComplaints"),
    },
  },
  ...(config.featureDiscoveryCreators && !config.featureSoloModel
    ? [
        {
          path: "/creators",
          name: "creatorsAll",
          components: {
            default: () => import("@/views/PageCreatorsList"),
            stories: () => import("@/views/Stories"),
          },
          props: { default: () => ({ tab: CreatorsTabsEnum.ALL }) },
        },
        {
          path: "/creators/online",
          name: "creatorsOnline",
          components: {
            default: () => import("@/views/PageCreatorsList"),
            stories: () => import("@/views/Stories"),
          },
          props: { default: () => ({ tab: CreatorsTabsEnum.ONLINE }) },
        },
        {
          path: "/creators/live",
          name: "creatorsLive",
          components: {
            default: () => import("@/views/PageCreatorsList"),
            stories: () => import("@/views/Stories"),
          },
          props: { default: () => ({ tab: CreatorsTabsEnum.LIVE }) },
        },
      ]
    : []),
];

export default routes.map(route => enrichRouteMeta(route, {}));
